import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../../global-config'
import {
  useApiOrdersSwrGetMiraklMessagingOrderInfo,
  userSubOrderAccessorIsMarketplaceOrder,
} from '../../../../order'
import { orderQuestionSelfServiceAccessorGetSubOrderDetailDamagedProductUrl } from '../../../../order-question'
import { useContactPageLastOrderContext } from '../ContactPageLastOrderContext'

import { type ContactPageSelfServiceShortcutProps } from './ContactPageSelfServiceShortcutProps'

export const ContactPageSelfServiceShortcutReportDamagedOrderCta: FC<
  ContactPageSelfServiceShortcutProps
> = ({ availability }) => {
  const globalConfig = useGlobalConfigContext()
  const { activeSubOrder, firstSubOrder, lastOrder } =
    useContactPageLastOrderContext()

  const subOrder = activeSubOrder ?? firstSubOrder
  const isMarketplace =
    subOrder !== undefined && userSubOrderAccessorIsMarketplaceOrder(subOrder)

  const { data: miraklOrderInfo, isLoading } =
    useApiOrdersSwrGetMiraklMessagingOrderInfo({
      enabled: isMarketplace,
      subOrderId: subOrder?.subOrderId,
    })

  if (
    isLoading ||
    !subOrder?.subOrderId ||
    !lastOrder?.orderMasterData?.orderNumber
  ) {
    return null
  }

  if (availability === 'disabled') {
    return (
      <Button color="secondary" disabled size="small">
        <FormattedMessage id="contact.self.service.report.damaged.order" />
      </Button>
    )
  }

  return (
    <Button<'a'>
      color="secondary"
      href={orderQuestionSelfServiceAccessorGetSubOrderDetailDamagedProductUrl({
        canOpenIncident: miraklOrderInfo?.canOpenIncident ?? false,
        config: globalConfig,
        order: lastOrder,
        subOrder,
      })}
      size="small"
      slots={{ root: 'a' }}
    >
      <FormattedMessage id="helpCenter.fragenBestellung.subOrderDetails.orderProblem.damagedProduct.title" />
    </Button>
  )
}
